export function formatarNome(nome) {
  const excecoes = new Set(["a", "o", "as", "os", "de", "dos", "das", "do", "da", "e", "ou", "para", "por", "no", "na", "nos", "nas"]);

  return nome.toLowerCase().split(" ").map((palavra, index) => {
    if (excecoes.has(palavra) && index !== 0) {
      return palavra;
    }
    return palavra.charAt(0).toUpperCase() + palavra.slice(1);
  }).join(" ");
}